module.exports = __webpack_public_path__ + "img/IDCard-negative.c590ecbd.png";